module.exports = __webpack_public_path__ + "img/default_profile_white.c1b73385.svg";